// extracted by mini-css-extract-plugin
export default {"wrap":"Report_wrap__EFTMs","tableContainer":"Report_tableContainer__6uRkh"};